<template>
    <div class="app_view-container" v-show="showImg" @click.stop.prevent>
        <div ref="images" class="app_view-images" v-viewer="viewerOptions" @hide="hideView" @hidden="hideView">
			<img v-for="(src, index) in imageList" :src="src" :key="index" class="image">
        </div>
        <ul class="app_view-btn_group">
            <li title="向左" @click="viewPre()" :class="{'app_view-disabled_btn': !showPre}">
                <a-icon type="left" />
            </li>
            <li title="放大" @click="viewZoom(true)">
                <a-icon type="plus-circle" />
            </li>
            <li title="缩小" @click="viewZoom(false)">
                <a-icon type="minus-circle" />
            </li>
            <li title="向右" @click="viewNext()" :class="{'app_view-disabled_btn': !showNext}">
                <a-icon type="right" />
            </li>
        </ul>
        <div class="app_view-close" @click="closeViewer">
            <a-icon type="close-circle" />
        </div>
    </div>

</template>
<script>
import Vue from "vue";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";

Vue.use(Viewer);
export default {
	name: "viewImg",
	props: {
		imgUrl: {
			type: String,
			default: "",
		},
		imageList: {
			type: Array,
			default: () => {
				return []
			}
		},
		imageIndex: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			showImg: false,
			viewer: null, // viewer对象
			viewerOptions: { // options选择项，即下面显示的按钮
				navbar: false,
				title: false,
				toolbar: false,
			},
			showPre: true,
			showNext: true,
		};
	},
	watch: {
		imageList: {
			handler(value) {
				if (value && value.length) {
					this.showImg = true;
					this.$nextTick(() => {
						this.viewer = this.$viewerApi({
							images: this.imageList,
							options: {
								initialViewIndex: this.imageIndex,
								hidden: () => {
									this.hideView();
								}
							},
						})
						this.updateBtnStatus();
					});
				}
			},
		},
		showImg: {
			handler(value) {
				if (value) {
					document.querySelector("body").style.overflow = "hidden";
				} else {
					document.querySelector("body").style.overflow = "visible";
				}
			},
			immediate: true,
		},
	},
	mounted() {
		window.addEventListener("mouseup", this.mouseup);
	},
	methods: {
		updateBtnStatus () {
			this.showPre = (this.viewer.index !== 0);
			this.showNext = (this.viewer.index !== (this.imageList.length - 1));
		},
		/**
         * @author: fangxiong
         * @function: 浏览上一张
         */
		viewPre() {
			this.viewer.prev();
			this.showPre = (this.viewer.index !== 0);
		},
		/**
         * @author: fangxiong
         * @function: 浏览下一张
         */
		viewNext() {
			this.viewer.next();
			this.updateBtnStatus();
		},
		/**
         * @author: fangxiong
         * @function: 还原
         */
		viewReset() {
			this.viewer.reset();
			this.updateBtnStatus();
		},
		/**
         * @author: fangxiong
         * @function: 左旋转、右旋转
         * @param flag {boolean} 判断左右旋转
         */
		viewRotate(flag) {
			const deg = flag ? 90 : -90;
			this.viewer.rotate(deg);
		},
		/**
         * @author: fangxiong
         * @function: 放大、缩小
         * @param flag {boolean} 判断左右旋转
         */
		viewZoom(flag) {
			const rate = flag ? 0.2 : -0.2;
			this.viewer.zoom(rate);
		},
		/**
         * @author: fangxiong
         * @function: 图片预览关闭时的回调
         */
		hideView() {
			this.showImg = false;
			this.$emit("update:imageList", []);
		},
		/**
         * @func 鼠标左键按下事件回调
         * @param event {object} 鼠标按下事件对象
         */
		mousedown(event) {
			// 获取当前鼠标的坐标
			this.mouse_x = event.pageX;
			this.mouse_y = event.pageY;

			// 图片节点坐标
			this.offset_x = this.$refs.card.offsetLeft; // x坐标
			this.offset_y = this.$refs.card.offsetTop; // y坐标
			window.addEventListener("mousemove", this.mousemove);
		},
		/**
         * @func 鼠标移动事件
         * @param event {object} 鼠标按下事件对象
         */
		mousemove(event) {
			// 计算鼠标移动了的位置
			const _x = event.pageX - this.mouse_x;
			const _y = event.pageY - this.mouse_y;

			this.top = `${this.offset_y + _y}px`;
			this.left = `${this.offset_x + _x}px`;
		},
		/**
         * @func 鼠标左键松开事件回调
         * @param event {object} 鼠标按下事件对象
         */
		mouseup() {
			window.removeEventListener("mousemove", this.mousemove);
		},

		/**
         * @func 关闭门店
         * @param event {object} 鼠标按下事件对象
         */
		closeViewer() {
			this.viewer.hide();
			this.hideView();
		},
	},
};
</script>
<style lang="less">
.app_view {
    &-container {
        .anticon {
            border-radius: 10px;
            box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.5);
            background: rgba(0, 0, 0, 0.18);
        }
    }

    &-btn_group {
        z-index: 2022;
        position: fixed;
        bottom: 50px;
        left: 50%;
        width: 400px;
        margin-left: -200px;
        box-sizing: border-box;
        text-align: center;
        li {
            display: inline-block;
            width: 65px;
            height: 65px;
            margin-right: 10px;
            font-size: 45px;
            color: #fff;
            cursor: pointer;
        }
    }

    &-close {
        z-index: 2022;
        position: fixed;
        top: 10px;
        right: 10px;
        color: #fff;
        font-size: 50px;
        cursor: pointer;
    }

    &-images {
        z-index: -1;
        position: relative;
        visibility: hidden;
        img {
            z-index: -1;
            position: relative;
        }
    }
	&-disabled {
		&_btn {
			opacity: 0;
		}
	}
}
.viewer-button {
    display: none !important;
}
.viewer-canvas {
    z-index: 2022;
    .viewer-move {
        z-index: 2022;
    }
}
.viewer-footer {
	display: none !important;
}
</style>
